import { Injectable, inject } from '@angular/core';
import { TableColumnSelectorComponent } from './table-column-selector/table-column-selector.component';
import { DialogService } from './ui-components.module';
import { MatDialogRef } from '@angular/material/dialog';

export type Column = { id: string; label: string };

@Injectable()
export class TableColumnSelectorService {
  private dialogService = inject(DialogService);


  private columnSelectionDialog: MatDialogRef<TableColumnSelectorComponent, any>;

  openColumnSelectionDialog(data: {
    columns: Column[];
    selectedColumns: string[];
    disabledColumns?: string[];
    storageKey: string;
    title?: string;
    subtitle?: string;
    sortable?: boolean;
  }) {
    this.columnSelectionDialog = this.dialogService.open(TableColumnSelectorComponent, {
      data: { ...data },
      width: '400px',
    });

    return this.columnSelectionDialog.componentInstance.outData$;
  }

  getSelectedColumns(storageKey: string): string[] {
    const columns = localStorage.getItem(storageKey);
    return JSON.parse(columns as string);
  }

  setSelectedColumns(storageKey: string, selectedColumns: string[]): string[] {
    localStorage.setItem(storageKey, JSON.stringify(selectedColumns));
    return selectedColumns;
  }
}
